export default function BaseGreeks() {
    return {
        PacketIdentifier: "G",
        MessageLength: 68,
        Token: 41881,
        IV: 0,
        DELTA: 0,
        THETA: 0,
        VEGA: 0,
        GAMMA: 0,
        IV_VWAP: 0,
        VANNA: 0,
        CHARM: 0,
        SPEED: 0,
        ZOMMA: 0,
        COLOR: 0,
        VOLGA: 0,
        VETA: 0,
        TGR: 0,
        TV: 0,
        DTR: 0,
    };
}
